module.exports = __webpack_public_path__ + "media/images/hero-banner-c2c51050ce9096c5ac03ae909b76f28c.jpg";